export enum NotifType {

    Notification = 0,

    Attention = 1
}